export const CoffeeMakerIcon = () => (
  <svg width="45" height="53" viewBox="0 0 45 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M43.25 2.75V10.75C43.25 11.8546 42.3546 12.75 41.25 12.75H17.25C16.1454 12.75 15.25 13.6454 15.25 14.75V42.25C15.25 43.3546 16.1454 44.25 17.25 44.25H39.75C40.8546 44.25 41.75 45.1454 41.75 46.25V50.25C41.75 51.3546 40.8546 52.25 39.75 52.25H2.75C1.64543 52.25 0.75 51.3546 0.75 50.25V2.75C0.75 1.64543 1.64543 0.75 2.75 0.75H41.25C42.3546 0.75 43.25 1.64543 43.25 2.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="7.25" cy="37.75" r="3.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M19.25 12.75L20.9821 15.75C21.3393 16.3688 21.9996 16.75 22.7141 16.75H33.9216C34.452 16.75 34.9607 16.5393 35.3358 16.1642L38.75 12.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M22.893 25.74L20.8514 22.8235C20.3875 22.1607 20.8616 21.25 21.6707 21.25H34.25C34.8023 21.25 35.25 21.6977 35.25 22.25V26.5251C35.25 26.6732 35.2829 26.8194 35.3463 26.9532L37.982 32.5175C39.0936 34.8644 39.0231 37.6 37.792 39.8864C36.8422 41.6501 35.0008 42.75 32.9976 42.75H24.8338C22.6265 42.75 20.5974 41.5381 19.5509 39.5946L19.2981 39.125C18.3329 37.3325 18.3425 35.1728 19.3236 33.3889L22.95 26.7954C23.1337 26.4615 23.1116 26.0522 22.893 25.74Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M35.25 23.75H40.25C42.4591 23.75 44.25 25.5409 44.25 27.75V35.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
